import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class;
import _regeneratorRuntime from "@babel/runtime/regenerator";
// 生命周期设计文档https://dashen.zhuanspirit.com/pages/viewpage.action?pageId=470189267

import { isiOS, compareVersion, isZZ } from "../utils/common";
import { zzsdk } from "../utils/initLoadSdk";
import Logger from "../utils/log";
var EVENTS = ['visibilitychange', 'pageshow', 'replaceState', 'pushState', 'popstate', 'pagehide', 'beforeunload'];

// 定义支持状态的枚举类型
var SupportStatus = /*#__PURE__*/function (SupportStatus) {
  SupportStatus["UNKNOWN"] = "unknown";
  SupportStatus["SUPPORTED"] = "supported";
  SupportStatus["UNSUPPORTED"] = "unsupported";
  return SupportStatus;
}(SupportStatus || {}); // 初始化为未知状态
var support = SupportStatus.UNKNOWN;
var wrapHistoryFn = function wrapHistoryFn(fnName) {
  var originFn = window.history[fnName];
  return function () {
    var ret = originFn.apply(this, arguments);
    var event = new Event(fnName);
    event.arguments = arguments;
    window.dispatchEvent(event);
    return ret;
  };
};
var getPageUrl = function getPageUrl() {
  try {
    if (typeof window === 'undefined') return '';
    var _window$location = window.location,
      hostname = _window$location.hostname,
      pathname = _window$location.pathname,
      hash = _window$location.hash;
    var url = hostname + pathname + "".concat(hash && hash.split('?')[0]);
    return url;
  } catch (e) {
    console.log(e);
  }
};
var getCallbackParam = function getCallbackParam(type, href) {
  try {
    if (!href) {
      href = getPageUrl();
    }
    href = encodeURIComponent(href);
    var time = new Date().getTime();
    return {
      type: type,
      href: href,
      time: time
    };
  } catch (e) {
    Logger.error('getCallbackParam' + e);
  }
};

// 返回当前的url
function getPath() {
  return location.href;
}
function loadJS(url, cb) {
  var head = window.document.getElementsByTagName('head')[0];
  var js = window.document.createElement('script');
  js.setAttribute('type', 'text/javascript');
  js.setAttribute('async', 'async');
  js.setAttribute('src', url);
  js.onload = cb;
  head.appendChild(js);
}
;
var PageLife = /*#__PURE__*/function () {
  function PageLife() {
    var _this = this;
    _classCallCheck(this, PageLife);
    _defineProperty(this, "oldPath", void 0);
    _defineProperty(this, "supportNative", void 0);
    _defineProperty(this, "zzJsSdk", void 0);
    _defineProperty(this, "initNativeEvent", function () {
      _this.zzJsSdk['onShow']({}, function (res) {
        if (res && res.code == 0) {
          Logger.info('lego生命周期执行onLoad');
          PageLife.onLoad();
          Logger.info('lego生命周期执行onShow');
          PageLife.onShow();
        }
      });
      _this.zzJsSdk['onHide']({}, function (res) {
        if (res && res.code == 0) {
          Logger.info('lego生命周期执行onHide');
          PageLife.onHide();
        }
      });
    });
    // 处理枚举的事件
    _defineProperty(this, "handleEvents", function (evt) {
      switch (evt === null || evt === void 0 ? void 0 : evt.type) {
        case 'pageshow':
          if (!_this.supportNative || !_this.zzJsSdk) {
            Logger.info('lego生命周期执行onLoad');
            PageLife.onLoad();
            Logger.info('lego生命周期执行onShow');
            PageLife.onShow();
          }
          break;
        case 'visibilitychange':
          if (!_this.supportNative || !_this.zzJsSdk) {
            if (document.visibilityState === 'visible') {
              Logger.info('lego生命周期执行onShow');
              PageLife.onShow();
            } else {
              Logger.info('lego生命周期执行onHide');
              PageLife.onHide();
            }
          }
          break;
        case 'pagehide':
          if (!_this.supportNative || !_this.zzJsSdk) {
            if (!isiOS()) {
              Logger.info('lego生命周期执行onHide');
              PageLife.onHide();
              Logger.info('lego生命周期执行onUnload');
              PageLife.onUnload();
            }
          }
          break;
        case 'beforeunload':
          if (!_this.supportNative || !_this.zzJsSdk) {
            if (isiOS()) {
              Logger.info('lego生命周期执行onHide');
              PageLife.onHide();
              Logger.info('lego生命周期执行onUnload');
              PageLife.onUnload();
            }
          }
        case 'popstate':
        case 'pushState':
        case 'replaceState':
          _this.wrapHandle(function (from, to) {
            if (from != to) {
              Logger.info('lego生命周期执行onHide');
              PageLife.onHide();
              Logger.info('lego生命周期执行onLoad');
              PageLife.onLoad();
              Logger.info('lego生命周期执行onShow');
              PageLife.onShow();
            }
          });
          break;
      }
    });
    _defineProperty(this, "add", function (type, callback) {
      var hook = type + 'Fns';
      if (Array.isArray(PageLife[hook])) {
        if (!PageLife[hook].includes(callback)) {
          PageLife[hook].push(callback);
        }
      }
    });
    this.init();
    Logger.info('lego生命周期初始化成功');
  }
  // 初始化sdk
  _createClass(PageLife, [{
    key: "initSdk",
    value: function initSdk(callback) {
      var _this2 = this;
      try {
        if (window.__ZZAPP__) {
          this.zzJsSdk = window.__ZZAPP__;
          Logger.info('lego需要的sdk已经加载，zzJsSdk全局变量获取成功');
          callback(true);
        } else {
          loadJS(zzsdk, function () {
            _this2.zzJsSdk = window.__ZZAPP__;
            Logger.info('lego加载sdk成功');
            callback(true);
          });
        }
      } catch (error) {
        Logger.warn('lego加载sdk不成功');
        callback(false);
      }
    }
  }, {
    key: "checkSdkSupport",
    value: function checkSdkSupport() {
      var zzVersion = navigator.userAgent.match(/zzVersion\/(\S*) zzT/);
      return !!(zzVersion && Array.isArray(zzVersion) && compareVersion(zzVersion[1], '10.0.0') === 1 && (window.zhuanzhuanMApplication || window.zhuanzhuanMApplicationIos));
    }
    // 初始化
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              try {
                this.initSdk(function (success) {
                  if (success) {
                    _this3.supportNative = _this3.checkSdkSupport();
                    if (_this3.supportNative) {
                      if (_this3.zzJsSdk) {
                        _this3.initNativeEvent();
                      }
                    }
                    // 存储旧的url
                    _this3.oldPath = getPath();

                    // 自定义监听 pushState replaceState
                    _this3.swizzleHistoryMethods();
                    // 为所有枚举的事件添加事件处理回调
                    if (!isZZ()) {
                      EVENTS.forEach(function (eventType) {
                        return addEventListener(eventType, _this3.handleEvents, true);
                      });
                    }
                  } else {
                    console.log('SDK 加载失败');
                    EVENTS.forEach(function (eventType) {
                      return addEventListener(eventType, _this3.handleEvents, true);
                    });
                  }
                });
              } catch (e) {
                Logger.error(e);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "swizzleHistoryMethods",
    value: function swizzleHistoryMethods() {
      window.history.pushState = wrapHistoryFn('pushState');
      window.history.replaceState = wrapHistoryFn('replaceState');
    }
  }, {
    key: "wrapHandle",
    value: function wrapHandle(callback) {
      var from = this.oldPath;
      var to = getPath();
      callback(from, to);
      this.oldPath = to;
    }
  }, {
    key: "removeListener",
    value: function removeListener() {
      var _this4 = this;
      EVENTS.forEach(function (evt) {
        return removeEventListener(evt, _this4.handleEvents, true);
      });
    }
  }]);
  return PageLife;
}();
_class = PageLife;
_defineProperty(PageLife, "onShowFns", []);
_defineProperty(PageLife, "onHideFns", []);
_defineProperty(PageLife, "onLoadFns", []);
_defineProperty(PageLife, "onUnloadFns", []);
_defineProperty(PageLife, "onShow", function () {
  try {
    var param = getCallbackParam('onShow', getPageUrl());
    if (Array.isArray(_class.onShowFns)) {
      _class.onShowFns.forEach(function (fn) {
        if (fn && typeof fn === 'function') fn(param);
      });
    }
    // 每次页面变动的时候，清空找靓机backup备份的参数
    window['getLegoBackUpParam'] = '';
  } catch (e) {}
});
_defineProperty(PageLife, "onHide", function () {
  try {
    var param = getCallbackParam('onHide', getPageUrl());
    if (Array.isArray(_class.onHideFns)) {
      _class.onHideFns.forEach(function (fn) {
        if (fn && typeof fn === 'function') fn(param);
      });
    }
  } catch (e) {}
});
_defineProperty(PageLife, "onLoad", function () {
  try {
    var param = getCallbackParam('onLoad', getPageUrl());
    var zpmshow = false;
    if (Array.isArray(_class.onLoadFns)) {
      _class.onLoadFns.forEach(function (fn) {
        if (fn && typeof fn === 'function') {
          // 保证在一次的页面加载中只执行一次zpmshow和保证能执行
          // 如果函数中存在 initPvLister字符组就把zpmshow置为true
          if (fn.toString().indexOf('initPvLister') > -1) {
            if (!zpmshow) {
              fn(param);
            }
            zpmshow = true;
          } else {
            fn(param);
          }
        }
      });
      // 如果zpmshow为false就执行
      if (!zpmshow) {
        //如果存在window['ZZ_LEGO_ZPMSHOW_FUNS']而且是函数就执行
        if (window['ZZ_LEGO_ZPMSHOW_FUNS'] && typeof window['ZZ_LEGO_ZPMSHOW_FUNS'] === 'function') {
          window['ZZ_LEGO_ZPMSHOW_FUNS']({});
        }
      }
    }
  } catch (e) {
    //如果存在window['ZZ_LEGO_ZPMSHOW_FUNS']而且是函数就执行
    if (window['ZZ_LEGO_ZPMSHOW_FUNS'] && typeof window['ZZ_LEGO_ZPMSHOW_FUNS'] === 'function') {
      window['ZZ_LEGO_ZPMSHOW_FUNS']({});
    }
  }
});
_defineProperty(PageLife, "onUnload", function () {
  try {
    var param = getCallbackParam('onUnLoad', getPageUrl());
    if (Array.isArray(_class.onUnloadFns)) {
      _class.onUnloadFns.forEach(function (fn) {
        if (fn && typeof fn === 'function') fn(param);
      });
    }
  } catch (e) {}
});
export default new PageLife();